<template>
    <div>
        <zm-row v-if="!isCreateTopic">
        <zm-select size="small" v-model="selectedTopic" filterable clearable class="describe-select"
            @change="refreshDetail" :loading="selectLoading" @visible-change="visibleChange">
            <zm-option v-for="item in topicList" :key="item" :value="item" :label="item"></zm-option>
        </zm-select>
        <zm-button size="small" style="margin-left: 5px" type="icon" icon="zm-icon-refresh" @click="refreshDetail"></zm-button>
        <zm-button size="small" style="margin-left: 5px" type="primary" plain @click="isCreateTopic = true" v-if="hasPermission">Create Topic</zm-button>
        </zm-row>
        <topicDescribeDetail :channelId="id" :topicUrl="selectedTopic" ref="detail"
        v-if="selectedTopic" @refresh="refresh" @cancelCreateTopic="cancelCreateTopic"
        :isCreateTopic="isCreateTopic"></topicDescribeDetail>
    </div>
</template>
<script>
import topicDescribeDetail from './topicDescribeDetail'
import { getChannelTopics } from '../../api/index'
export default {
    name: 'topicDescribe',
    components: {
        topicDescribeDetail
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            isCreateTopic: false,
            id: '',
            selectLoading: false,
            loading: false,
            topicList: [],
            selectedTopic: '',
            data: {},
            search: '',
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created () {
        this.id = this.$route.params.id
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.select = JSON.parse(localStorage.params).select
            this.selectedTopic = JSON.parse(localStorage.params).selectedTopic
            this.fetchData(false)
            this.refreshDetail()
        } else {
            this.fetchData(true)
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.data.partitions.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search) > -1
                    })
                })
            }
            return this.data.partitions
        }
    },
    watch: {
        selectedTopic () {
            this.setURL()
        },
        search () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { selectedTopic, select } = this
            const data = { path: this.$route.path, selectedTopic, select }
            localStorage.path = this.$route.path
            localStorage.params = JSON.stringify(data)
        },
        refreshDetail () {
            this.$nextTick(() => {
                this.$refs.detail.fetchDescribe(this.selectedTopic)
            })
        },
        visibleChange (val) {
            if (val && !this.topicList.length) {
                this.fetchData(false)
            }
        },
        cancelCreateTopic () {
            this.isCreateTopic = false
        },
        refresh (newUrl) {
            this.isCreateTopic = false
            this.selectLoading = true
            getChannelTopics(this.id).then(response => {
                this.selectLoading = false
                this.topicList = response
                if (newUrl) {
                    this.selectedTopic = newUrl
                    this.refreshDetail()
                } else {
                    this.selectedTopic = this.topicList[0]
                    this.refreshDetail()
                }
            }).catch(() => {
                this.selectLoading = false
            })
        },
        fetchData (isCreated) {
            this.isCreateTopic = false
            this.selectLoading = true
            getChannelTopics(this.id).then(response => {
                this.selectLoading = false
                this.topicList = response
                if (isCreated) {
                    this.selectedTopic = this.topicList[0]
                    this.fetchDescribe(this.topicList[0])
                }
            }).catch(() => {
                this.selectLoading = false
            })
        }
    }
}
</script>
<style>
.describe-form {
    margin: 10px;
    color: #747487;
    padding-right: 80px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.describe-container {
    min-height: 300px;
}
.config-form {
    line-break: anywhere;
    word-break: break-all;
}
.describe-select {
    width: 500px;
}
</style>
